module.exports = __webpack_public_path__ + "./images/28a4f871430415ad2dbb89e7c3ec039d.webp";